/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".botonera-Cabecera[_ngcontent-%COMP%]{height:62px}.boton-altura[_ngcontent-%COMP%]{margin-top:.5rem}"];
export { styles as styles };
